export const FETCH_CONTACTS_BEGIN = 'FETCH_CONTACTS_BEGIN';
export const FETCH_CONTACTS_SUCCESS = 'FETCH_CONTACTS_SUCCESS';
export const FETCH_CONTACTS_FAILURE = 'FETCH_CONTACTS_FAILURE';
export const CLEAR_CONTACTS = 'CLEAR_CONTACTS';
export const EXTRACT_CONTACTS = 'EXTRACT_CONTACTS';
export const EXTRACT_CONTACT = 'EXTRACT_CONTACT';
